import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as filterAPI from 'api/Inspect';
// import * as scoreCardAPI from 'api/Scorecard';
// import { MAIN_FILTER } from 'utils/common';
import { objectToArray, sortByPriorityIndex } from 'utils/redux';
import { validateErrorAndCheckArray } from 'utils/validation';
const initialState = {
  status: '',
  data: null,
  InspectConfigData: null,
  features_filter: null,
  LOB: null,
  LOB2: null,
  AnalyticsConfigData: null,
  LOBTeam: null,
  LOBTeamAgent: null,
  rangeDate: null,
  fields: {},
  selected: {
    LOB: [],
    LOBTeam: [],
    LOBTeamAgent: [],
    fields: {},
    rowFilter: {
      LOB: false,
      LOBTeam: false,
      LOBTeamAgent: false
    }
  },
  ui: {
    LOB: {
      status: '',
      loading: false,
      flag: false
    },
    LOBTeam: {
      status: '',
      loading: false,
      flag: false
    },
    LOBTeamAgent: {
      status: '',
      loading: false
    },
    loading: false
  },
  // main_filter: MAIN_FILTER,
  error: null
};
const getFilterState = (state) => state.filter;
const getInspectConfigData = createAsyncThunk('analyzefilter/getInspectConfigData', async (_, { dispatch, rejectWithValue }) => {
  try {
    const res = await filterAPI.getInspectConfigData();
    const data = res?.data?.data;
    console.log('data111', data);
    if (data) {
      let extra_filter = {};
      if (data.advancefilter) {
        for (const key in data.advancefilter.features_data) {
          extra_filter[key] = {
            slug: key,
            ...data.advancefilter.features_data[key]
          };
        }
        extra_filter = sortByPriorityIndex(extra_filter);
      } else {
        extra_filter = null;
      }
      let feature_filter = {};
      let fields = {};
      if (data.addcolumn) {
        for (const key in data?.addcolumn?.features_data) {
          fields[key] = objectToArray(data?.addcolumn?.features_data[key]);
          //     slug: key,
          //     ...data?.addcolumn?.features_data[key]
          // };
        }
        // fields = data?.addcolumn?.features_data;
        dispatch(setFieldsData(fields));
      } else {
        fields = null;
      }

      return {
        ...data,
        data: {
          extra_filter: extra_filter,
          feature_filter: feature_filter
        }
      };
    }
    return null;
  } catch (error) {
    return rejectWithValue(error);
  }
});

const filterSlice = createSlice({
  name: 'analyzefilter',
  initialState: initialState,

  reducers: {
    resetState: () => {
      return initialState;
    },
    setDefaultLobTeamAgent: (state, action) => {
      const {
        LOB,
        LOBTeam,
        LOBTeamAgent
        // selectedLOB,
        // selectedLOBTeam,
        // selectedLOBTeamAgent,
      } = action.payload;
      state.LOB = LOB;
      state.LOBTeam = LOBTeam;
      state.LOBTeamAgent = LOBTeamAgent;
      // state.selected.LOB = selectedLOB;
      // state.selected.LOBTeam = selectedLOBTeam;
      // state.selected.LOBTeamAgent = selectedLOBTeamAgent;
    },
    setLobTeamDataByLob: (state, { payload }) => {
      state.LOBTeam = payload;
      state.LOBTeamAgent = [];
    },
    setLOBTeamAgentDataByLobTeam: (state, { payload }) => {
      state.LOBTeamAgent = payload;
    },
    changeDateRange: (state, action) => {
      state.rangeDate = action.payload;
    },
    setFieldsData: (state, action) => {
      state.fields = action.payload;
    },
    handleLobAllFilterChange: (state) => {
      const flag = state.selected.rowFilter.LOB;
      state.LOB = state.LOB.map((obj) => ({ ...obj, value: !flag }));
      state.selected.LOB = state.LOB.map((obj) => ({
        ...obj,
        value: !flag
      }));
      state.selected.rowFilter.LOB = !flag;
    },
    handleAllTeamFilterChange: (state) => {
      const flag = state.selected.rowFilter.LOBTeam;
      state.LOBTeam = state.LOBTeam.map((obj) => ({
        ...obj,
        value: !flag
      }));
      state.selected.LOBTeam = state.LOBTeam.map((obj) => ({
        ...obj,
        value: !flag
      }));
      state.selected.rowFilter.LOBTeam = !flag;
    },

    handleAllAgentFilterChange: (state) => {
      const flag = state.selected.rowFilter.LOBTeamAgent;
      state.LOBTeamAgent = state.LOBTeamAgent.map((obj) => ({
        ...obj,
        value: !flag
      }));
      state.selected.rowFilter.LOBTeamAgent = !flag;
    },

    handleLobFilterChange: (state, action) => {
      const findIndex = state.LOB.findIndex((item) => item.id === action.payload.id);
      const flag = action.payload.value;
      if (findIndex !== -1) {
        if (!state.selected.LOB.includes(state.LOB[findIndex])) {
          state.selected.LOB[findIndex] = state.LOB[findIndex];
        }

        if (flag !== undefined) {
          if (!state.selected.LOB[findIndex]) {
            state.selected.LOB[findIndex] = {}; // Initialize if not defined
          }
          state.selected.LOB[findIndex].value = flag;
          if (!flag) state.selected.rowFilter.LOB = flag;
          else {
            const filtered = state.LOB.filter((item) => item.value === flag);
            if (state.LOB.length === filtered.length) {
              state.selected.rowFilter.LOB = flag;
            }
          }
        }

        if (!state.selected.rowFilter.LOB) {
          state.selected.rowFilter.LOBTeam = false;
        }
      }
    },
    handleTeamFilterChange: (state, action) => {
      // console.log(action.payload, 'letmecheck');
      state.ui.LOBTeam.flag = true;
      const flag = action.payload.value;
      const findIndex = state.LOBTeam.findIndex((item) => item.id === action.payload.id);
      if (findIndex !== -1) {
        if (!state.selected.LOBTeam.includes(state.LOBTeam[findIndex])) {
          state.selected.LOBTeam[findIndex] = state.LOBTeam[findIndex];
        }

        if (flag !== undefined) {
          if (!state.selected.LOBTeam[findIndex]) {
            state.selected.LOBTeam[findIndex] = {}; // Initialize if not defined
          }

          state.selected.LOBTeam[findIndex].value = flag;

          if (!flag) state.selected.rowFilter.LOBTeam = flag;
          else {
            const filtered = state.LOBTeam.filter((item) => item.value === flag);
            console.log(filtered, 'filtered');
            if (state.LOBTeam.length === filtered.length) {
              state.selected.rowFilter.LOBTeam = flag;
            }
          }
        }
        if (!state.selected.rowFilter.LOBTeam) {
          state.selected.rowFilter.LOBTeamAgent = false;
        }
      }
    },

    handleAgentFilterChange: (state, action) => {
      const findIndex = state.LOBTeamAgent.findIndex((item) => item.id === action.payload.id);
      const flag = action.payload.value;
      if (!state.selected.LOBTeamAgent.includes(state.LOBTeamAgent[findIndex])) {
        state.selected.LOBTeamAgent[findIndex] = state.LOBTeamAgent[findIndex];
      }
      state.selected.LOBTeamAgent[findIndex].value = flag;
      if (!flag) state.selected.rowFilter.LOBTeamAgent = flag;
      else {
        const filtered = state.LOBTeamAgent.filter((item) => item.value === flag);
        if (state.LOBTeamAgent.length === filtered.length) {
          state.selected.rowFilter.LOBTeamAgent = flag;
        }
      }
      // state.LOBTeamAgent[findIndex].value = action.payload.value;
    },
    clearLobTeamAgent: (state) => {
      const updatedLOB = state.LOB.map((item) => ({
        ...item,
        value: false
      }));
      state.LOB = updatedLOB;
      state.LOBTeam = [];
      state.LOBTeamAgent = [];
      state.selected.LOB = [];
      state.selected.LOBTeam = [];
      state.selected.LOBTeamAgent = [];
      // state.rangeDate = [];
    },

    handleSetExtraFilterData: (state, action) => {
      state.data.extra_filter[action.payload.filter_type].selected = action.payload.value;
    },
    handleRemoveExtraFilterData: (state, action) => {
      state.data.extra_filter[action.payload.filter_type].selected = null;
    },

    handleSetMultipleExtraFilterData: (state, action) => {
      if (state.data.extra_filter[action.payload.filter_type].selected instanceof Array) {
        if (state.data.extra_filter[action.payload.filter_type].selected.includes(action.payload.value)) {
          const prevData = state.data.extra_filter[action.payload.filter_type].selected;
          var index = prevData.indexOf(action.payload.value);
          if (index !== -1) {
            prevData.splice(index, 1);
          }
          // state.data.extra_filter[action.payload.filter_type].selected.pop(
          //   action.payload.value
          // );
        } else {
          state.data.extra_filter[action.payload.filter_type].selected.push(action.payload.value);
        }
      } else state.data.extra_filter[action.payload.filter_type].selected = [action.payload.value];
    },
    handleSetsingleExtraFilterData: (state, action) => {
      state.data.extra_filter[action.payload.filter_type].selected = [action.payload.value];
    },
    handleRemoveMultipleExtraFilterData: (state, action) => {
      const prevData = state.data.extra_filter[action.payload.filter_type].selected;
      var index = prevData.indexOf(action.payload.value);
      if (index !== -1) {
        prevData.splice(index, 1);
      }
      // state.data.extra_filter[action.payload.filter_type].selected.pop(
      //   action.payload.value
      // );
    },
    handleRemoveMultipleExtraFilterDataFromApplied: (state, action) => {
      if (validateErrorAndCheckArray(state.extra_filter[action.payload.filter_type].selected)) {
        if (validateErrorAndCheckArray(action.payload.value)) {
          state.extra_filter[action.payload.filter_type].selected = null;
        } else {
          const prevData = state.extra_filter[action.payload.filter_type].selected;
          var index = prevData.indexOf(action.payload.value);
          if (index !== -1) {
            prevData.splice(index, 1);
          }
        }
      } else {
        state.extra_filter[action.payload.filter_type].selected = null;
      }
      if (state.data.extra_filter) {
        state.data.extra_filter = state.extra_filter;
      }
    },
    handleSetMultipleFeatureFilterData: (state, action) => {
      const { filter_type, index, value } = action.payload;
      state.data.feature_filter[filter_type][index].selected = value;
    },
    handleRemoveFeatureExtraFilterData: (state, action) => {
      const { filter_type, index } = action.payload;

      state.data.feature_filter[filter_type][index].selected = null;
    },
    setFeatureFilter: (state, action) => {
      state.features_filter = action.payload;
    },
    setExtraFilter: (state) => {
      state.extra_filter = state.data.extra_filter;
    },

    handleChangeAddtionalFields: (state, action) => {
      const { keyName, values, flag } = action.payload;

      //   if (!state.selected.fields.hasOwnProperty(keyName)) {
      //     state.selected.fields[keyName] = flag;
      //   } else {
      //     state.selected.fields[keyName] = flag;
      //   }

      if (!state.selected.fields.hasOwnProperty.call(keyName)) {
        state.selected.fields[keyName] = flag;
      } else {
        state.selected.fields[keyName] = flag;
      }

      Object.keys(values).map((item, index) => {
        state.fields[keyName][index].selected = flag;
      });
    },
    handleChangeAddtionalSubFields: (state, action) => {
      const { parentKey, flag, index } = action.payload;
      state.fields[parentKey][index].selected = flag;
      if (!flag) state.selected.fields[parentKey] = flag;
      else {
        const original = Object.values(state.fields[parentKey]);
        const filtered = original.filter((item) => item.selected === flag);
        if (original.length === filtered.length) {
          state.selected.fields[parentKey] = flag;
        }
      }
    },

    handleSpeakerFilterChange: (state, action) => {
      state.data.extra_filter[action.payload.filter_type].selected = action.payload.value;
    },
    handleSearchFilterChange: (state, action) => {
      state.data.extra_filter[action.payload.filter_type].selected = action.payload.value;
    },
    clearExtraFilter: (state) => {
      if (state.data.extra_filter) {
        Object.keys(state.data.extra_filter).forEach((key) => {
          state.data.extra_filter[key].selected = null;
        });
      }
    },

    setAllfilterFromParent: (state, action) => {
      if (action.payload) {
        state.data = action.payload.data;
        state.features_filter = action.payload.features_filter;
        state.LOB = action.payload.LOB;
        state.LOB2 = action.payload.LOB2;
        state.LOBTeam = action.payload.LOBTeam;
        state.LOBTeamAgent = action.payload.LOBTeamAgent;
        state.rangeDate = action.payload.rangeDate;
        state.fields = action.payload.fields;
        state.selected = action.payload.selected;
      }
    },
    setSelectedDatafromParent: (state, action) => {
      if (action.payload) {
        Object.values(state.data.feature_filter).map((item) => {
          item.map((sub_cat) => {
            if (sub_cat.slug === action.payload) {
              sub_cat.selected = 'Not Adhered';
            } else {
              sub_cat.selected = null;
            }
          });
          // console.log('setSelectedDatafromParent',(modifyData));
        });
      }
    }
  },

  extraReducers: {
    [getInspectConfigData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getInspectConfigData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      const { data, ...others } = action.payload;
      state.InspectConfigData = others;
      state.LOB = others.select_lob?.value;
      state.LOBTeam = !state.LOB ? others?.select_team?.value : [];
      state.LOBTeamAgent = !state.LOB && !state.LOBTeam ? others?.select_agent?.value : [];
      state.rangeDate = others?.select_date?.value;
      state.data = data;
    },

    [getInspectConfigData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    }
  }
});

const {
  resetState,
  setFieldsData,
  changeDateRange,
  handleLobFilterChange,
  handleTeamFilterChange,
  handleAgentFilterChange,
  handleLobAllFilterChange,
  handleAllTeamFilterChange,
  handleAllAgentFilterChange,
  handleSetExtraFilterData,
  handleRemoveExtraFilterData,
  setFeatureFilter,
  setExtraFilter,
  handleSetMultipleExtraFilterData,
  handleRemoveMultipleExtraFilterData,
  handleSetMultipleFeatureFilterData,
  handleSetsingleExtraFilterData,
  handleRemoveFeatureExtraFilterData,
  handleRemoveMultipleExtraFilterDataFromApplied,
  handleChangeAddtionalFields,
  handleChangeAddtionalSubFields,
  clearExtraFilter,
  clearLobTeamAgent,
  setSelectedDatafromParent,
  setAllfilterFromParent,
  handleSpeakerFilterChange,
  handleSearchFilterChange,
  setDefaultLobTeamAgent,
  setLobTeamDataByLob,
  setLOBTeamAgentDataByLobTeam
} = filterSlice.actions;

export default filterSlice.reducer;

export {
  getFilterState,
  resetState,
  setFieldsData,
  clearLobTeamAgent,
  changeDateRange,
  setExtraFilter,
  handleLobFilterChange,
  handleTeamFilterChange,
  handleAgentFilterChange,
  handleLobAllFilterChange,
  handleAllTeamFilterChange,
  handleAllAgentFilterChange,
  handleSetExtraFilterData,
  handleRemoveExtraFilterData,
  handleSetMultipleExtraFilterData,
  handleRemoveMultipleExtraFilterData,
  handleRemoveMultipleExtraFilterDataFromApplied,
  handleSetMultipleFeatureFilterData,
  handleSetsingleExtraFilterData,
  handleRemoveFeatureExtraFilterData,
  handleChangeAddtionalFields,
  handleChangeAddtionalSubFields,
  setFeatureFilter,
  clearExtraFilter,
  setSelectedDatafromParent,
  setAllfilterFromParent,
  handleSpeakerFilterChange,
  handleSearchFilterChange,
  setDefaultLobTeamAgent,
  setLobTeamDataByLob,
  setLOBTeamAgentDataByLobTeam,
  getInspectConfigData
};
